import type { ReactNode } from 'react';
import { DS2 } from '../../theme/designTokens';
import { AtmosphericGlow } from './AtmosphericGlow';

interface GlowSpec {
  width:  number;
  height: number;
  top:    number;
  leftOffset: number;
  radius: number;
}

interface Props {
  glow1: GlowSpec;
  glow2: GlowSpec;
  /** Centered column width — 363 for the narrow auth-card family (Login,
   * Forgot Password), wider for full-bleed result pages (e.g. success). */
  maxWidth?: number;
  children: ReactNode;
}

/**
 * Shared background/frame for the DS2 Auth family (Login, Forgot Password,
 * …): dark page background, two atmospheric glows, and a centered content
 * column. Extracted from the approved LoginScreen — glow geometry and
 * column width are per-instance (each Figma auth frame specifies its own
 * exact values), so this carries no defaults of its own.
 */
export function AuthPageShell({ glow1, glow2, maxWidth = 363, children }: Props) {
  return (
    <div
      style={{
        position:   'relative',
        flex:       1,
        background: DS2.color.pageBg,
        display:    'flex',
        padding:    '48px 24px',
        boxSizing:  'border-box',
      }}
    >
      <div aria-hidden="true" style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        <AtmosphericGlow width={glow1.width} height={glow1.height} top={glow1.top} leftOffset={glow1.leftOffset} radius={glow1.radius} />
        <AtmosphericGlow width={glow2.width} height={glow2.height} top={glow2.top} leftOffset={glow2.leftOffset} radius={glow2.radius} />
      </div>

      <div
        style={{
          position:      'relative',
          display:       'flex',
          flexDirection: 'column',
          alignItems:    'center',
          maxWidth,
          width:         '100%',
          margin:        'auto',
        }}
      >
        {children}
      </div>
    </div>
  );
}
